import PointerTouchIcon from '@/Components/Icons/PointerTouchIcon.vue';
import ViceStethoscope from '@/Components/Icons/ViceStethoscope.vue';
import ViceSmartphone from '@/Components/Icons/ViceSmartphone.vue';
import ViceGlasses from '@/Components/Icons/ViceGlasses.vue';

export const stethoscope = {
  steps: [
    { label: 'stethoscope' },
    {
      icon: PointerTouchIcon,
      description: 'Open <b>the Ekuore app</b> on your smartphone',
    },
    {
      icon: ViceStethoscope,
      description: 'Follow the steps on the <b>smartphone</b>',
    },
  ],
};

export const smartglasses = {
  steps: [
    { label: 'smartglasses' },
    {
      icon: PointerTouchIcon,
      description: 'Open <b>the CE app</b> on your smart glasses',
    },
    {
      icon: ViceGlasses,
      description: '<b>Activate the smart glasses</b> by scanning the QR Code.',
    },
  ],
};

export const smartphone = {
  steps: [
    { label: 'smartphone' },
    {
      icon: PointerTouchIcon,
      description: 'Open <b>the VCE app</b> on your smartphone',
    },
    {
      icon: ViceSmartphone,
      description: 'Follow the steps on the <b>smartphone</b>',
    },
  ],
};
